import React from "react";
import { Info } from "lucide-react";

import { cn } from "@/lib/utils";

import { Button } from "./button";

//

export interface InfoButtonProps {
  iconSize?: number;
}

//

export const InfoButton: React.FC<React.ComponentProps<typeof Button> & InfoButtonProps> = ({
  className,
  iconSize,
  ...props
}) => {
  return (
    <Button size={"icon"} variant={"ghost"} className={cn("size-6", className)} {...props}>
      <Info size={iconSize ?? 14} />
    </Button>
  );
};
